/*
 * Time Tracking Page Messages
 *
 * This contains all the text for the Time Tracking Page.
 */

import { defineMessages } from 'react-intl';

export const scope = 'src.pages.TimeTrackingPage.components.DateRangeModal';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Date Range',
  },
  fromDateRangeLabel: {
    id: `${scope}.fromDateRangeLabel`,
    defaultMessage: 'From',
  },
  toDateRangeLabel: {
    id: `${scope}.toDateRangeLabel`,
    defaultMessage: 'To',
  },
  dateRangeButton: {
    id: `${scope}.dateRangeButton`,
    defaultMessage: 'Date Range',
  },
  saveButton: {
    id: `${scope}.saveButton`,
    defaultMessage: 'Save Setting',
  },
  dateRangeLabel: {
    id: `${scope}.dateRangeLabel`,
    defaultMessage: 'Date Range',
  },
});
